import PropTypes from 'prop-types';
import React from 'react';
import { get, isNil } from 'lodash';
import { FlexRow, FlexCol } from '../sharedComponents/FlexGrid';
import ImageUnavailable from '../sharedComponents/ImageUnavailable';
import StarRating from '../sharedComponents/StarRating';
import * as utils from './utils';
import LocationName from './LocationName';

const propTypes = {
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    index: PropTypes.number,
    item: PropTypes.shape({
        preview_image_url: PropTypes.string,
        name: PropTypes.string
    }),
    onCardSelect: PropTypes.func.isRequired,
    windowWidth: PropTypes.number
};

export const RecommendationsGridCard = (props) => {

    const detailURL = utils.getTargetUri(props.item);
    const defaultPricingMessage = 'see Details';
    const priceStr = utils.getPriceRangeLabel(props.item);
    let priceUnit = utils.getPriceRangeUnit(props.item);

    if (props.item.entity_type === 'campground' && isNil(priceStr)) {
        priceUnit = defaultPricingMessage;
    }

    let cardLabel = null;
    if (priceStr) {
        cardLabel = `${props.item.name} - ${priceStr} ${priceUnit}`;
    }

    const getAverageRating = (item) => {
        return Number.parseFloat(get(item, 'average_rating', 0.0));
    };

    const getNumberOfRatings = (item) => {
        return Number.parseInt(get(item, 'number_of_ratings', 0), 10);
    };

    const averageRating = getAverageRating(props.item);
    const numberOfRatings = getNumberOfRatings(props.item);

    return (
        <a
            href={detailURL}
            className="recommendations-grid-card-wrapper"
            onClick={() => props.onCardSelect(props.item, detailURL, props.index)}
            aria-label={cardLabel}
            target="_blank"
            rel="noopener noreferrer">
            <FlexRow hasGutters={false} className="recommendations-grid-card">
                <FlexCol xs="variable" className="mr-2">
                    <div className="recommendations-grid-card--image-wrap">
                        {props.item.preview_image_url &&
                            <img
                                src={props.item.preview_image_url}
                                alt={props.item.name}
                                className="recommendations-grid-card--image" />
                        }
                        {!props.item.preview_image_url &&
                            <ImageUnavailable />
                        }
                    </div>
                </FlexCol>
                <FlexCol xs="auto">
                    <FlexRow flexDirection="column" hasGutters={false}>
                        <FlexCol xs={12}>
                            <LocationName
                                className="recommendations-grid-card--name"
                                name={props.item.name} />
                        </FlexCol>
                        <FlexCol xs={12} className="recommendations-grid-card--location">
                            <LocationName
                                name={props.item.parent_name} />
                        </FlexCol>

                        <FlexCol sm={12} className="recommendations-grid-card--stars-price">
                            {averageRating > 0 &&
                                <StarRating
                                    rating={averageRating}
                                    format="fmt2"
                                    size="sm"
                                    voteCount={numberOfRatings} />
                            }
                            {priceStr &&
                                <div className="recommendations-grid-card--price-end">
                                    {`${priceStr} per night`}
                                </div>
                            }
                        </FlexCol>
                    </FlexRow>
                </FlexCol>
            </FlexRow>
        </a>
    );
};

RecommendationsGridCard.propTypes = propTypes;

export default RecommendationsGridCard;
